<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="name"
                    label="分类名称"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=50
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="parent_id"
                    label="上级分类"
                    prop="parent_id"
                    :help="formErr.parent_id"
                    :validateStatus='!formErr.parent_id||formErr.parent_id==""?"":"error"'
            >
                <a-select v-model="form.parent_id" class="seachs"   :disabled="form.parent_id==0&&childLeng>0">
                    <a-select-option :value="item.id" v-for="item in seleList" :title="item.name">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.id" v-for="item in this.statusList"> {{item.name}} </a-radio>

                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer>
    </div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"

    import API from "../api";

    export default {
        name: "newForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            childLeng:{type: [String, Number],},
            editId:{type: [String, Number],},
            content: {
                type: String,
                default: '请输入您的内容'
            }
        },
        data() {
            return {
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                seleList:[],
                statusList:[],
                drawerConfig:drawerConfig,
                datas:[],
                childLengs:"",
                form: {
                    name:"",
                    parent_id:0,
                    status:1,
                },
                formErr: {
                    name:"",
                    parent_id:"",
                    status:"",
                },
                rules: {
                    name: [{required: true, message: "请输入分类名称 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16 },
                },
            };
        },
        watch:{
            visible:function(a,b){
                this.getFormData()
            },
            // childLeng:function(a,b){
            //     this.childLengs=a
            // },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data.info
                        this.datas=JSON.stringify(res.data.data.info.parent_id)
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        computed: {

        },
        methods: {
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.statusList=res.data.data.status_list
                    this.seleList=res.data.data.parent_list
                })
            },

            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                    name:"",
                    parent_id:"",
                    status:"",
                }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        let  type =1
                        var promises = new Promise(function (resolve, reject) {
                            type =1
                            _this.seleList.forEach((item,index)=>{
                                if(item.id==subData.parent_id&&item.art_count*1>0&&_this.datas!=subData.parent_id){
                                    type =2
                                    _this.$confirm({
                                        title: '提示',
                                        content: '您所选上级分类已有文章,确定添加下级分类么?',
                                        onOk() {
                                            submitForm(url, subData).then(res => {
                                                if (res == true) {
                                                    _this.onClose()
                                                } else {
                                                    res.map((item, index) => {
                                                        _this.formErr[item.field] = item.msg
                                                    })
                                                }
                                            })},
                                        onCancel() {
                                            console.log('Cancel');
                                        },
                                    });
                                }
                            })
                            resolve(type)
                        });
                        promises.then(res => {
                            if(res!=2){
                                submitForm(url, subData).then(res => {
                                    if (res == true) {
                                        this.onClose()
                                    } else {
                                        res.map((item, index) => {
                                            this.formErr[item.field] = item.msg
                                        })
                                    }
                                })
                            }
                        })





                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
</style>
